import { render, staticRenderFns } from "./AlertDoneButton.vue?vue&type=template&id=212c700f&scoped=true"
import script from "./AlertDoneButton.vue?vue&type=script&lang=js"
export * from "./AlertDoneButton.vue?vue&type=script&lang=js"
import style0 from "./AlertDoneButton.vue?vue&type=style&index=0&id=212c700f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212c700f",
  null
  
)

export default component.exports